/* tslint:disable */
import { Form } from "./Form"

export class Respondent {
		Email: string;

		Form: Form;
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Respondent.ts